import React from "react";
import { connect, useDispatch } from "react-redux";
import { Box, Tooltip, Switch, Divider, Stack } from "@mui/material";
import * as maplayerAction from "../../../infofleet/ducks/maplayer";

import MapZoomLock from "../../../app/partials/layout/MapZoomLock";
import MapActionsPanel from "../../../app/partials/layout/MapActionsPanel";
import NotificationPanelToggler from "./NotificationPanelToggle";
import Feedback from "../../../app/partials/layout/Feedback";
import UserProfile from "../../../app/partials/layout/UserProfile";

import ClusterIcon from "../../../assets/infofleet/cluster.png";
import { toAbsoluteUrl } from "../../utils/utils";

function Topbar({ maplayer }) {
  const dispatch = useDispatch();
  const clusterview = maplayer.ClusterView;

  const clusterChange = (event) => {
    dispatch(maplayerAction.actions.ClusterView(event.target.checked));
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{
        bgcolor: "background.paper",
        padding: "0 12px",
        height: 48,   
        borderRadius: 1,
        boxShadow: 'none !important'
      }}
    >
      {/* Cluster View with Tooltip */}
      <Tooltip
        title={
          <>
            <strong>Cluster View : </strong> Vehicle icons are grouped into clusters displaying the total count. Enable this option if you have a large number of vehicles for better map performance and clarity.
          </>
        }
        placement="bottom"
        slotProps={{
          tooltip: {
            sx: {
              bgcolor: '#fff',
              color: '#000',
              fontSize: 10,
              borderRadius: 1,
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
            },
          },
        }}
      >
        <Box display="flex" alignItems="center" sx={{ cursor: "pointer" }}>
          <img
            src={ClusterIcon}
            alt="Cluster"
            style={{ width: 24 }}
          />
          <Switch
            checked={Boolean(clusterview)}
            onChange={clusterChange}
            color="primary"
            inputProps={{ "aria-label": "cluster view toggle" }}
          />
        </Box>
      </Tooltip>

      {/* Vertical divider */}
      <Divider orientation="vertical" flexItem />

      {/* Map Zoom Lock */}
      <Box>
        <MapZoomLock />
      </Box>

      <Divider orientation="vertical" flexItem />

      {/* Map Actions Panel */}
      <Box>
        <MapActionsPanel
          bgImage={toAbsoluteUrl("/media/misc/bg-2.jpg")}
          skin="dark"
          iconType=""
          useSVG="true"
          gridNavSkin="light"
        />
      </Box>

      <Divider orientation="vertical" flexItem />

      {/* Notification Panel Toggler */}
      <Box>
        <NotificationPanelToggler />
      </Box>

      <Divider orientation="vertical" flexItem />

      {/* Feedback */}
      <Box>
        <Feedback
          iconType=""
          useSVG="true"
          bgImage={toAbsoluteUrl("/media/misc/bg-1.jpg")}
        />
      </Box>

      <Divider orientation="vertical" flexItem />

      {/* User Profile */}
      <Box>
        <UserProfile showAvatar={true} showHi={true} showBadge={false} />
      </Box>
    </Stack>
  );
}

const mapStateToProps = ({ maplayer }) => ({
  maplayer,
});

export default connect(mapStateToProps, { maplayerAction })(Topbar);
